import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/PlatformLearningScheme'

// 枚举

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

/**
 * 期数相关的查询
@author: eleven
@date: 2020/3/11
 */
export class IssueParamDTO {
  /**
   * 期数id
   */
  issueId?: string
  /**
   * 培训班学习方案ID集合
   */
  schemeIdList?: Array<string>
  /**
   * 方案名称
   */
  scheme?: string
  /**
   * 年度
   */
  year?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 考试类别ID
@see com.fjhb.platform.core.learningscheme.v1.preexam.kernel.appservice.convention.CommoditySkuPropertyConst
   */
  examTypeId?: string
  /**
   * 培训形态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.TrainingFormConst
   */
  trainingForm?: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure?: string
  /**
   * 单位id集合
   */
  unitIdList?: Array<string>
}

/**
 * @author: eleven
@date: 2020/3/27
 */
export class LearningSchemeParamDTO {
  /**
   * 培训班学习方案ID集合
   */
  schemeIdList?: Array<string>
  /**
   * 方案名称
   */
  scheme?: string
  /**
   * 年度
   */
  year?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 考试类别ID
@see com.fjhb.platform.core.learningscheme.v1.preexam.kernel.appservice.convention.CommoditySkuPropertyConst
   */
  examTypeId?: string
  /**
   * 培训形态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.TrainingFormConst
   */
  trainingForm?: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure?: string
  /**
   * 单位id集合
   */
  unitIdList?: Array<string>
}

/**
 * @author eleven
 */
export class JSKQEffectiveLSCreateRequest {
  /**
   * 单位id集合
   */
  unitIdList: Array<string>
  /**
   * 有效期天数
   */
  validDay: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsDto
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 考试类别ID
   */
  examTypeId?: string
  /**
   * 考试类别名称
   */
  examTypeName?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 专业名称
   */
  professionName?: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
@see PreExamLSCreateRequest#dailyExaminationSettings
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure?: string
  /**
   * 所属考纲
   */
  syllabusId?: string
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

/**
 * @author eleven
 */
export class LSIssueCreateRequest {
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数名称
   */
  title?: string
  /**
   * 培训开始时间
   */
  startTime?: string
  /**
   * 培训结束时间
   */
  endTime?: string
  /**
   * 线下考试时间
   */
  offlineExamTime?: string
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 排序
   */
  sort: number
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsRequest
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
}

/**
 * 期数更新对象
@author: eleven
@date: 2020/3/13
 */
export class LSIssueUpdateRequest {
  /**
   * 要更新期数的学习方案ID
   */
  schemeId?: string
  /**
   * 要更新的期数ID
   */
  issueId?: string
  /**
   * 期数名称
   */
  title?: string
  /**
   * 培训开始时间
   */
  startTime?: string
  /**
   * 培训结束时间
   */
  endTime?: string
  /**
   * 线下考试时间
   */
  offlineExamTime?: string
  /**
   * 排序
   */
  sort: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsDto
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
}

/**
 * @author eleven
 */
export class LearningSchemeCreateRequest {
  /**
   * 单位id集合
   */
  unitIdList: Array<string>
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 考试类别ID
   */
  examTypeId?: string
  /**
   * 考试类别名称
   */
  examTypeName?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 专业名称
   */
  professionName?: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
@see PreExamLSCreateRequest#dailyExaminationSettings
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure?: string
  /**
   * 所属考纲
   */
  syllabusId?: string
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

export class UpDownSettingsDto {
  upping: boolean
  upPlainTime?: string
  downPlainTime?: string
}

/**
 * 课程学习方式设置信息
 */
export class CourseLearningSettingsRequest {
  /**
   * 是否启用课程学习方式
   */
  enabled: boolean
  /**
   * 课程包ID集合
   */
  packageIds?: Array<string>
  /**
   * 是否仅系统推送
   */
  systemPush: boolean
}

/**
 * 每日一卷
@author eleven
@date 2020/12/8
 */
export class DailyExaminationSettingsRequest {
  /**
   * 是否启用每日一卷
   */
  enabled: boolean
  /**
   * 每日一卷名称
   */
  name?: string
  /**
   * 考试卷id
   */
  examPaperId?: string
  /**
   * 发布类型
0:不发布 1:马上发布 2:限时
   */
  publishType: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
  /**
   * 每日一卷id
   */
  id?: string
}

/**
 * 每日一练配置信息
 */
export class DailyPracticeSettingsRequest {
  /**
   * 是否启用每日一练
   */
  enabled: boolean
}

/**
 * 易错题练习配置
 */
export class ErrorPronePracticeSettingsRequest {
  /**
   * 是否启用易错题练习
   */
  enabled: boolean
}

/**
 * 考试学习方式设置信息
 */
export class ExamLearningSettingsRequest {
  /**
   * 是否启用考试学习方式
   */
  enabled: boolean
  /**
   * 考试名称
   */
  name?: string
  /**
   * 试卷ID
   */
  examPaperId?: string
  /**
   * 考试时长，单位分钟
   */
  examTimeLength: number
  /**
   * 考试次数 0表示不限制次数
   */
  examCount: number
  /**
   * 及格分数
   */
  passScore: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
  /**
   * 最短提交时长
   */
  minSubmitTimeLength: number
  /**
   * 多选漏选是否的分
   */
  less: boolean
  /**
   * 漏选得分模式
0:不得分，适用于漏选不得分情况
1:全得
2:得一半
3:平均得分
   */
  missScorePattern: number
  /**
   * 是否配置考试时间
   */
  configExamTime: boolean
  /**
   * 开考时间
   */
  beginTime?: string
  /**
   * 结束时间
   */
  endTime?: string
}

export class PreExamLSUpdateRequest {
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
@see PreExamLSUpdateRequest#dailyExaminationSettings
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

/**
 * 试题练习学习方式配置
 */
export class QuestionPracticeLearningSettingsRequest {
  /**
   * 是否启用试题练习
   */
  enabled: boolean
  /**
   * 抽题方式，1：指定考纲方式，2：按试题题型及抽题比例
   */
  fetchWay: number
  /**
   * 是否开放真题
   */
  openReal: boolean
  /**
   * 是否开放练习题
   */
  openPractice: boolean
  /**
   * 是否开放模拟题
   */
  openSimulation: boolean
  /**
   * 真题比率
   */
  realRatioValue: number
  /**
   * 练习题比率
   */
  practiceRatioValue: number
  /**
   * 模拟题比率
   */
  simulationRatioValue: number
}

/**
 * 学员身份查询信息
 */
export class StudentIdentityPageQueryRequest {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 用户ID集合
   */
  userIds?: Array<string>
  /**
   * 报名时间起始查询
   */
  startCreateTime?: string
  /**
   * 报名时间截止查询
   */
  endCreateTime?: string
  /**
   * 分组ID集合
   */
  groupIds?: Array<string>
  /**
   * 是否延长有效期查询，null不查询
   */
  isRenewal?: boolean
}

/**
 * 学员身份排序
 */
export class StudentIdentityPageSortRequest {
  /**
   * null 不排序，true 升序，false降序
   */
  usageEndDate?: boolean
}

/**
 * 商品SKU上下架设置
 */
export class UpDownSettingsRequest {
  /**
   * 是否上架
true: 如果商品SKU处于下架状态将进行立即上架
false: 如果商品SKU处于上架状态将进行立即下架
   */
  upping: boolean
  /**
   * 计划上架时间
如果 upping 为 true 该值无效
   */
  upPlainTime?: string
  /**
   * 计划下架时间
如果 upping 为 false 该值无效
   */
  downPlainTime?: string
}

/**
 * eleven
 */
export class IssueLinkResponse {
  /**
   * 学习方式类型
1表示课程学习方式
2表示考试学习方式
3表示课后练习学习方式
4表示教学计划学习方式
5表示调查问卷学习方式（旧）
6表示研讨学习方式
7表示作业学习方式
8表示调查问卷学习方式
   */
  learningType: number
  /**
   * 学习资源类型
1表示课程
2表示选课规则
3表示考试场次
4表示课后练习
5表示教学计划
6表示调查问卷（旧）
7表示研讨
8表示作业
9表示调查问卷
10表示练习
   */
  learningResourceType: number
  /**
   * 学习方式ID
   */
  learningId: string
}

/**
 * 学习方案分页查询
@author: eleven
@date: 2020/3/27
 */
export class LearningSchemeBaseResponse {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  name: string
  /**
   * 培训班封面图片地址
   */
  picture: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 培训形态
   */
  trainingForm: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure: string
}

/**
 * @author eleven
 */
export class LearningSchemeResponse {
  /**
   * 学习方案信息
   */
  learningScheme: PreExamLSResponse
  /**
   * 期数信息
   */
  issueAndCommoditySkuList: Array<IssueAndCommoditySkuResponse>
}

/**
 * 商品sku属性
@author: eleven
@date: 2020/3/12
 */
export class CommoditySkuProperty {
  /**
   * 考试类别ID
@see com.fjhb.platform.core.learningscheme.v1.preexam.kernel.appservice.convention.CommoditySkuPropertyConst
   */
  examTypeId: string
  /**
   * 考试类别名称
   */
  examTypeName: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 专业名称
   */
  professionName: string
  /**
   * 年度id
   */
  yearId: string
  /**
   * 年度
   */
  year: string
}

/**
 * 商品分页对象1
@author: eleven
@date: 2020/3/11
 */
export class IssueDTO {
  /**
   * 单位id
   */
  unitId: string
  /**
   * 期数商品skuId
   */
  commoditySkuId: string
  /**
   * 新训商品SkuId
   */
  newEffectiveCommoditySkuId: string
  /**
   * 方案id
   */
  schemeId: string
  /**
   * 方案名称
   */
  scheme: string
  /**
   * 期数id
   */
  issueId: string
  /**
   * 期数名称
   */
  issueTitle: string
  /**
   * 学习截止时间
   */
  learningEndTime: string
  /**
   * 学习开始时间
   */
  learningStartTime: string
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 排序
   */
  sort: number
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * sku属性对象
   */
  skuProperty: CommoditySkuProperty
  /**
   * SKU 状态
库存中:100  已上架:200  已下架:300
@see CommoditySkuStateConst
   */
  state: number
  /**
   * 培训形态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.TrainingFormConst
   */
  trainingForm: string
  /**
   * 所属考纲
   */
  syllabusId: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure: string
}

/**
 * 课程学习方式信息
 */
export class CourseLearningResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用课程学习方式
   */
  enabled: boolean
  /**
   * 课程包ID集合
   */
  packageIds: Array<string>
  /**
   * 是否仅系统推送
   */
  systemPush: boolean
}

/**
 * 每日一卷
@author eleven
@date 2020/12/8
 */
export class DailyExaminationResponse {
  /**
   * 是否启用每日一练
   */
  enabled: boolean
  /**
   * 每日一卷id
   */
  id: string
  /**
   * 每日一卷名称
   */
  name: string
  /**
   * 考试卷id
   */
  examPaperId: string
  /**
   * 发布类型
0:不发布 1:马上发布 2:限时
   */
  publishType: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
}

/**
 * 每日一练信息
 */
export class DailyPracticeResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用每日一练
   */
  enabled: boolean
}

/**
 * 易错题练习信息
 */
export class ErrorPronePracticeResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用易错题练习
   */
  enabled: boolean
}

/**
 * 考试学习方式信息
 */
export class ExamLearningResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用考试学习方式
   */
  enabled: boolean
  /**
   * 考试名称
   */
  name: string
  /**
   * 试卷ID
   */
  examPaperId: string
  /**
   * 考试时长，单位分钟
   */
  examTimeLength: number
  /**
   * 考试次数 0表示不限制次数
   */
  examCount: number
  /**
   * 及格分数
   */
  passScore: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
  /**
   * 最短提交时长
   */
  minSubmitTimeLength: number
  /**
   * 开考时间
   */
  beginTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 多选漏选是否的分
   */
  less: boolean
  /**
   * 漏选得分模式
0:不得分，适用于漏选不得分情况
1:全得
2:得一半
3:平均得分
   */
  missScorePattern: number
  /**
   * 是否配置考试时间
   */
  configExamTime: boolean
}

/**
 * 期数和商品SKU信息
 */
export class IssueAndCommoditySkuResponse {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期数ID
   */
  issueId: string
  /**
   * 商品SkuId
   */
  commoditySkuId: string
  /**
   * 标题
   */
  title: string
  /**
   * 开始时间
   */
  startTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price: number
  /**
   * 上下架设置
   */
  upDownSettings: UpDownSettingsResponse
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
}

/**
 * 考前学习方案信息
 */
export class PreExamLSResponse {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  name: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm: string
  /**
   * 课程学习方式信息
   */
  courseLearning: CourseLearningResponse
  /**
   * 考试学习方式信息
   */
  examLearning: ExamLearningResponse
  /**
   * 试题练习学习方式信息
   */
  questionPracticeLearning: QuestionPracticeLearningResponse
  /**
   * 每日一练信息
@see PreExamLSResponse#dailyExamination
   */
  dailyPractice: DailyPracticeResponse
  /**
   * 易错题练习信息
   */
  errorPronePractice: ErrorPronePracticeResponse
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure: string
  /**
   * 所属考纲
   */
  syllabusId: string
  /**
   * 每日一卷
   */
  dailyExamination: DailyExaminationResponse
}

/**
 * 试题练习学习方式信息
 */
export class QuestionPracticeLearningResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用试题练习
   */
  enabled: boolean
  /**
   * 抽题方式，1：指定考纲方式，2：按试题题型及抽题比例
   */
  fetchWay: number
  /**
   * 是否开放真题
   */
  openReal: boolean
  /**
   * 是否开放练习题
   */
  openPractice: boolean
  /**
   * 是否开放模拟题
   */
  openSimulation: boolean
  /**
   * 真题比率
   */
  realRatioValue: number
  /**
   * 练习题比率
   */
  practiceRatioValue: number
  /**
   * 模拟题比率
   */
  simulationRatioValue: number
}

/**
 * 商品SKU上下架设置
 */
export class UpDownSettingsResponse {
  /**
   * 是否上架
true: 如果商品SKU处于下架状态将进行立即上架
false: 如果商品SKU处于上架状态将进行立即下架
   */
  upping: boolean
  /**
   * 计划上架时间
如果 upping 为 true 该值无效
   */
  upPlainTime: string
  /**
   * 计划下架时间
如果 upping 为 false 该值无效
   */
  downPlainTime: string
}

export class IssueDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<IssueDTO>
}

export class LearningSchemeBaseResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<LearningSchemeBaseResponse>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取期数形态学习方案下面的期数商品
   * @param schemeId
   * @return
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listIssue(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.listIssue,
    operation?: string
  ): Promise<Response<Array<IssueAndCommoditySkuResponse>>> {
    return commonRequestApi<Array<IssueAndCommoditySkuResponse>>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 获取期数学习方式信息
   * @param issueId
   * @return
   * @param query 查询 graphql 语法文档
   * @param issueId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listIssueLink(
    issueId: string,
    query: DocumentNode = GraphqlImporter.listIssueLink,
    operation?: string
  ): Promise<Response<Array<IssueLinkResponse>>> {
    return commonRequestApi<Array<IssueLinkResponse>>(SERVER_URL, {
      query: query,
      variables: { issueId },
      operation: operation
    })
  }

  /**   * 获取期数分页
   * @param paramDTO
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageIssue(
    params: { page: Page; paramDTO: IssueParamDTO },
    query: DocumentNode = GraphqlImporter.pageIssue,
    operation?: string
  ): Promise<Response<IssueDTOPage>> {
    return commonRequestApi<IssueDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取学习方案分页
   * @param paramDTO
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageLearningScheme(
    params: { page: Page; paramDTO: LearningSchemeParamDTO },
    query: DocumentNode = GraphqlImporter.pageLearningScheme,
    operation?: string
  ): Promise<Response<LearningSchemeBaseResponsePage>> {
    return commonRequestApi<LearningSchemeBaseResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 创建有效期形态的学习方案
   * @param request
   * @param request
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createEffectiveLS(
    request: JSKQEffectiveLSCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createEffectiveLS,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 创建期数形态的学习方案
   * @param request
   * @param issueCreateRequestList
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createIssueLS(
    params: { request: LearningSchemeCreateRequest; issueCreateRequestList: Array<LSIssueCreateRequest> },
    mutate: DocumentNode = GraphqlImporter.createIssueLS,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async exportStudentIdentityList(
    params: { queries?: StudentIdentityPageQueryRequest; sort?: StudentIdentityPageSortRequest },
    mutate: DocumentNode = GraphqlImporter.exportStudentIdentityList,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 更新期数形态的学习方案
   * @param request
   * @param issueUpdateRequestList
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateIssueLS(
    params: { request: PreExamLSUpdateRequest; issueUpdateRequestList: Array<LSIssueUpdateRequest> },
    mutate: DocumentNode = GraphqlImporter.updateIssueLS,
    operation?: string
  ): Promise<Response<LearningSchemeResponse>> {
    return commonRequestApi<LearningSchemeResponse>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }
}

export default new DataGateway()
